import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import getCardFromState from '../../utils/cardStateStorage/getCardFromState';
import setCardInState from '../../utils/cardStateStorage/setCardInState';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';

const setCardDescriptionInputSchema = z.object({
  newDescription: z.string().describe('The new description of the card'),
});

export default function setCardDescriptionTool() {
  async function execute(params: ToolExecuteParams<typeof setCardDescriptionInputSchema>) {
    const {newDescription} = params.input;

    const card = getCardFromState();

    card.description = newDescription;

    setCardInState(card);

    return toolResult('Card description set successfully');
  }

  return tool({
    name: V2CardAgentToolName.SetCardDescription,
    description: 'Set the description of the current card',
    displayName: 'Setting card description',
    inputSchema: setCardDescriptionInputSchema,
    execute,
  });
}
